import React from "react"
import PropTypes from "prop-types"
import { Map, TileLayer, Marker, Popup } from "react-leaflet"
import './event-map.css'

class EventMap extends React.Component {

    static propTypes = {
        position: PropTypes.array,

        zoom: PropTypes.number,

        markerText: PropTypes.string
    }

    static defaultProps = {
        position: [-43.531, 172.636],
        zoom: 14,
        markerText: ""
    }

    render() {
        return (
            <Map center={this.props.position} zoom={this.props.zoom}>
                <TileLayer
                    url="https://api.mapbox.com/styles/v1/glitterbox/ck3wg3n0h1zsu1cneu5pc8r4s/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZ2xpdHRlcmJveCIsImEiOiJjazN3ZmJwNDYweHdvM2tzMXo1ZjhyN3JpIn0.yRrHGmT3qsUyuZybc63L8g"
                    attribution='Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>'
                />
                {this.props.markerText !== "" &&
                <Marker position={this.props.position}>
                    <Popup>{this.props.markerText}</Popup>
                </Marker>
                }
            </Map>
        );
    }
}

export default EventMap